import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { DateFormatPicker } from 'primary-components';

import { FormulaUtils } from 'utils';

const DateFormat = ({ onChange, dateFormat = undefined, dateFormatOverridden = false }) => (
  <Fragment>
    <div
        className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
        id="date-format"
    >
      Date format
    </div>
    <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
      <DateFormatPicker
          dateFormat={dateFormatOverridden ? FormulaUtils.OVERRIDDEN : dateFormat}
          disabled={dateFormatOverridden}
          fixed
          labelId="date-format"
          menuPortalTarget={document.querySelector('.ng-office-app')}
          noError
          onChange={onChange}
          variant="border"
      />
    </div>
  </Fragment>
)

DateFormat.propTypes = {
  dateFormat: PropTypes.string,
  dateFormatOverridden: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default DateFormat;
